import Web3 from 'web3'
import { useEffect, useState, useRef } from 'react'
import { useWeb3React } from '@web3-react/core'
import { getWeb3 } from '../utils'

/**
 * Provides a web3 instance using the provider provided by useWeb3React
 * with a fallback of an httpProver
 * Recreate web3 instance only if the provider change
 */
const useWeb3 = () => {
  const { library } = useWeb3React()
  const refEth = useRef(library)
  const [web3, setweb3] = useState(library || getWeb3())

  useEffect(() => {
    if (library !== refEth.current) {
      setweb3(library ? new Web3(library) : getWeb3())
      refEth.current = library
    }
  }, [library])

  return web3
}

export default useWeb3